/*
  <scroll-carousel>: a horizontal slider built on native scrolling with
  scroll-snap, so trackpads, touch and keyboard work without extra code.
  Adds previous/next buttons and a progress bar.

  Markup:
    <scroll-carousel>
      <div data-carousel-track> <div data-carousel-slide>…</div> … </div>
      <button data-carousel-prev></button>
      <div data-carousel-progress><span></span></div>
      <button data-carousel-next></button>
    </scroll-carousel>
*/
if (!customElements.get('scroll-carousel')) {
  customElements.define(
    'scroll-carousel',
    class ScrollCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-carousel-track]');
        if (!this.track) return;
        this.prevButton = this.querySelector('[data-carousel-prev]');
        this.nextButton = this.querySelector('[data-carousel-next]');
        this.progress = this.querySelector('[data-carousel-progress]');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        this.prevButton?.addEventListener('click', () => this.step(-1));
        this.nextButton?.addEventListener('click', () => this.step(1));
        this.track.addEventListener('scroll', () => this.update(), { passive: true });
        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this.track);
        this.update();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }

      step(direction) {
        const slide = this.track.querySelector('[data-carousel-slide]');
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const distance = slide ? slide.getBoundingClientRect().width + gap : this.track.clientWidth;
        this.track.scrollBy({
          left: direction * distance,
          behavior: this.reducedMotion.matches ? 'auto' : 'smooth',
        });
      }

      update() {
        const { scrollLeft, scrollWidth, clientWidth } = this.track;
        const maxScroll = scrollWidth - clientWidth;
        this.toggleAttribute('data-scrollable', maxScroll > 1);
        if (this.prevButton) this.prevButton.disabled = scrollLeft <= 1;
        if (this.nextButton) this.nextButton.disabled = scrollLeft >= maxScroll - 1;
        if (this.progress && scrollWidth > 0) {
          this.progress.style.setProperty('--carousel-thumb-width', `${(clientWidth / scrollWidth) * 100}%`);
          this.progress.style.setProperty('--carousel-thumb-left', `${(scrollLeft / scrollWidth) * 100}%`);
        }
      }
    }
  );
}
